import { useTranslation } from 'react-i18next';

import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger
} from '@/components/Select';
import Spinner from '@/components/Spinner';
import CurrencyIcon from '@/icons/currency.svg';
import { cn } from '@/utils';

import { useCurrencySelector } from './hooks';

function CurrencySelector({ footer, className, size }) {
	const { t } = useTranslation();

	const {
		open,
		setOpen,
		onChange,
		currency,
		currencies = [],
		fetchingCurrencies
	} = useCurrencySelector({ fetchOnOpen: footer });

	return (
		<Select
			value={currency}
			onValueChange={onChange}
			open={open}
			onOpenChange={setOpen}
			required
			className={cn(footer ? 'bg-black' : 'bg-white')}
		>
			<SelectTrigger
				size={size}
				className={cn(
					'group gap-2 p-0',
					footer
						? 'cursor-pointer border-none bg-black text-white hover:text-red data-[placeholder]:text-white hover:data-[placeholder]:text-red'
						: 'border-gray-200 bg-white text-grey-500 hover:text-grey-500',
					className
				)}
				aria-label={t('common.currency')}
			>
				<div
					className={cn(
						'flex items-center gap-2',
						footer ? 'px-1' : 'px-0'
					)}
				>
					{footer && (
						<CurrencyIcon className={cn(footer && 'text-inherit')} />
					)}
					<span className="inline-block grow whitespace-nowrap text-inherit">
						{currency ? currency?.toUpperCase() : t('common.currency')}
					</span>
				</div>
			</SelectTrigger>
			<SelectContent
				className="relative min-h-20 bg-white text-grey-500"
				side={footer ? 'top' : 'bottom'}
			>
				{fetchingCurrencies && (
					<Spinner className={cn('absolute inset-0 m-auto')} size={24} />
				)}
				{currencies.map((value, index) => (
					<SelectItem
						className={cn(
							'text-grey-500 hover:bg-grey-100',
							footer
								? 'data-[state=checked]:bg-red-background data-[state=checked]:text-red'
								: 'data-[state=checked]:bg-grey-100 data-[state=checked]:text-black'
						)}
						key={value + index}
						value={value}
						onClick={() => onChange(value)}
					>
						{value.toUpperCase()}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
}

export default CurrencySelector;
